/**
 * Hard upper bound on the decoded (raw XML) byte size of a CDA document that CTW will
 * render. At or above this size, the BFF refuses to buffer/parse the document and the
 * frontend refuses to decode/render it; the user is directed to download the original
 * instead. Distinct from the 5 MB warning threshold
 * (`excessivelyLargeDocumentSizeThresholdInBytes` in the server CDA parsers), where
 * documents still render behind a caution banner.
 *
 * This limit is in DECODED bytes. When a payload is still base64-encoded (FHIR
 * `Binary.data`), its encoded form is 4/3 of the decoded size, so the limit corresponds to
 * ~26,666,668 base64 characters — use {@link estimatedDecodedSizeOfBase64InBytes} to
 * compare encoded payloads against it.
 */
export const maximumRenderableCdaDocumentSizeInBytes = 20_000_000;

/**
 * Estimated decoded byte size of a base64 string given its character length (3 decoded
 * bytes per 4 encoded characters; padding makes this an overestimate by at most 2 bytes,
 * immaterial at this limit's scale).
 */
export const estimatedDecodedSizeOfBase64InBytes = (base64CharacterLength: number): number =>
  Math.floor((base64CharacterLength * 3) / 4);
